import request from '../request'

export function listSalePriceList(query) {
  return request.post('/sale/salePriceList/list', {
    currentPage: query.pageIndex,
    pageSize: query.pageSize,
    priceListCode: query.priceListCode,
    priceListName: query.priceListName,
    customerName: query.customerName,
    approveStatus: query.approveStatus
  })
}

export function getSalePriceList(id) {
  return request.get(`/sale/salePriceList/info/${id}`)
}

export function saveOrUpdateSalePriceList(data) {
  const path = data.priceListId ? '/sale/salePriceList/update' : '/sale/salePriceList/save'
  return request.post(path, data)
}

export function deleteSalePriceList(priceListId) {
  return request.post('/sale/salePriceList/delete', { priceListId })
}

export function approveSalePriceList(priceListId) {
  return request.post('/sale/salePriceList/approve', { priceListId })
}

export function unapproveSalePriceList(priceListId) {
  return request.post('/sale/salePriceList/unapprove', { priceListId })
}

export function submitSalePriceList(priceListId) {
  return request.post('/sale/salePriceList/submit', { priceListId })
}

export function resolveSalePriceListPrices(payload) {
  return request.post('/sale/salePriceList/resolvePrices', {
    customerId: payload.customerId,
    bizDate: payload.bizDate,
    materialIds: payload.materialIds || []
  })
}
